import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map, filter, reduce } from 'rxjs/operators';
import { MiraieService } from './miraie.service';
import { Logininfo } from '../classes/Loginifo';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  public loginID = new Logininfo();
  public sessionSubject = new Subject<Logininfo>();
  public sessionState = this.sessionSubject.asObservable();

  constructor(
    private http: MiraieService,
  ) {
  }
  /**
   * ログイン
   */
  login(userid: string, password: string) {
    var url = "login";
    let param = { userid, password };
    return this.http.post(url, param).pipe(
      map(res => {
        if (res['state'] == 'success' || res['state'] == 'noRegister') {
          this.loginID.user_code = res['user_code'];
          this.loginID.name1 = res['name1'];
          this.loginID.name2 = res['name2'];
          this.loginID.email = res['email'];
          this.loginID.division_code = res['division_code'];
          this.loginID.division_name = res['division_name'];
          this.loginID.authority_code = res['authority_code'];
          this.loginID.auth = res['auth'];
          this.loginID.is_admin = res['is_admin'];
          this.loginID.del_customer = res['del_customer'];
          this.loginID.is_sales = res['is_sales'];
          this.loginID.is_construction = res['is_construction'];
          this.loginID.is_design = res['is_design'];
          this.loginID.is_office = res['is_office'];
          } else {
          this.loginID.clear();
        }
        this.sessionSubject.next(this.loginID);
        return res['state'];
      })
    );
  }


  /**
   * ログアウト
   * 本来はセッションを切断処理
   */
  logout() {
    this.sessionClear();
    this.sessionSubject.next(this.loginID);
  }

  /**
   * 
   */
  userRegister(param) {
    var url = "userlist/register";

    return this.http.post(url, param);
  }
  /**
   * 
   */
  userDelete(param) {
    var url = "userlist/delete";

    return this.http.post(url, param);
  }

  /**
   * パスワード登録
   */
  register(password: string, confirm: string) {
    var url = "register";
    if (this.loginID) {
      let userid = this.loginID.email;
      let param = { userid, password, confirm };

      return this.http.post(url, param).pipe(
        map(res => {
          if (res['state'] == "success") {
            this.sessionSubject.next(this.loginID);
          }
          return res['state'];
        })
      );
    }
  }

  resetPassword(user_code: number) {
    var url = "userlist/reset";

    let param = { user_code: user_code };

    return this.http.post(url, param);
  }

  /**
   * ユーザー氏名取得
   * @param code 事業所コード　0で全員取得
   * @param managed 監視対象
   * @param is_sales 営業担当
   * @param is_construction 工事担当
   */
  getUserList(code: number, managed = 0, is_sales = 0, is_construction = 0) {
    var url = "userlist";

    let param = {
      'division_code': code,
      'managed': managed,
      'is_sales': is_sales,
      'is_construction': is_construction
    };

    return this.http.post(url, param);
  }
  /**
   * ユーザー情報取得
   * @param code 
   */
  getUser(code: number) {
    var url = "getuser";

    let param = { user_code: code };

    return this.http.post(url, param);
  }

  /**
   * セッション切断
   */
  sessionClear() {
    /*
    this.loginID.user_code = null;
    this.loginID.name1 = '';
    this.loginID.name2 = '';
    this.loginID.email = '';
    this.loginID.division_code = null;
    this.loginID.division_name = null;
    this.loginID.authority_code = null;
    */
    this.loginID.clear();
  }

  getName() {
    if (this.loginID.name1 != '' && this.loginID.name2 != '') {
      if (this.loginID.name2) {
        return this.loginID.name1 + ' ' + this.loginID.name2;
      } else {
        return this.loginID.name1;
      }
    }
    return '';
  }

  getUserCode() {
    return this.loginID.user_code;
  }

  getAuthorityCode() {
    return this.loginID.authority_code;
  }

  getAuthority() {
    return this.loginID.auth;
  }

  getDivisionCode() {
    return this.loginID.division_code;
  }

  getDivision() {
    return { division_code: this.loginID.division_code, division_name: this.loginID.division_name };
  }

  getLoginStatus() {
    return this.loginID;
  }
}
